/* Product interest is enquiry context. Existing destination, consent and form-ID controls remain authoritative. */
(function (factory) {
  'use strict';
  var api = factory();
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  if (typeof window === 'undefined') return;
  if (window.JJOPSEnquiry) { window.JJOPSEnquiry.mount(); return; }
  window.JJOPSEnquiry = api;
  api.mount();
  document.addEventListener('DOMContentLoaded', api.mount);
  document.addEventListener('shopify:section:load', api.mount);
  window.addEventListener('pageshow', api.mount);
})(function () {
  'use strict';
  var mounted = typeof WeakSet !== 'undefined' ? new WeakSet() : null;
  var productEvents = false;

  function quantity(value) {
    var raw = String(value == null ? '' : value);
    return /^[1-9]\d{0,5}$/.test(raw) ? raw : '';
  }

  function handle(value) {
    return typeof value === 'string' && /^[a-z0-9]+(?:-[a-z0-9]+)*$/.test(value) && value.length <= 120 ? value : '';
  }

  function choose(product, params, existing) {
    var desired = handle(existing.handle) || handle(params.get('model'));
    if (!product || !desired || product.handle !== desired || typeof product.title !== 'string' || !Array.isArray(product.variants)) return null;
    // A restored/manual selection is never replaced by a model or variant from another URL.
    if (existing.input && !existing.handle) return null;
    var variantId = existing.variant || (params.get('model') === desired ? params.get('variant') : '');
    var variant = product.variants.find(function (row) {
      return row && /^\d{1,20}$/.test(String(row.id)) && String(row.id) === String(variantId);
    });
    return {
      handle: desired,
      title: product.title.slice(0, 200),
      variant: variant ? String(variant.id) : '',
      variantTitle: variant && typeof variant.title === 'string' ? variant.title.slice(0, 160) : '',
      qty: existing.qty || ((!params.get('model') || params.get('model') === desired) ? quantity(params.get('qty')) : '')
    };
  }

  function productURL(base, selectedId, radios, updateQuantity) {
    var url = new URL(base, 'https://www.jucjet.com');
    if (!/\/pages\/request-a-quote$/.test(url.pathname) || !/^\d{1,20}$/.test(String(selectedId))) return null;
    url.searchParams.set('variant', String(selectedId));
    if (updateQuantity) {
      if (quantity(radios)) url.searchParams.set('qty', quantity(radios));
      else url.searchParams.delete('qty');
    }
    return url.pathname + url.search + (url.hash || '#jj-quote');
  }

  function testURL(base, search, origin) {
    var url = new URL(base, origin);
    if (url.origin !== origin) return null;
    if (new URLSearchParams(search).get('jj_test') === '1') url.searchParams.set('jj_test', '1');
    else url.searchParams.delete('jj_test');
    return url.pathname + url.search + url.hash;
  }

  function mountForm(form) {
    if (!mounted || mounted.has(form)) return;
    mounted.add(form);
    var returnField = form.querySelector('input[name="return_to"]');
    if (returnField) {
      var back = testURL(returnField.value, window.location.search, window.location.origin);
      if (back) returnField.value = back;
    }
    var productField = form.querySelector('[data-jj-selected-product]');
    var variantField = form.querySelector('[data-jj-selected-variant]');
    var variantTitle = form.querySelector('[data-jj-selected-variant-title]');
    var input = form.querySelector('[data-jj-product-input]');
    var label = form.querySelector('[data-jj-product-label]');
    var qty = form.querySelector('[data-jj-qty]');
    var hint = form.querySelector('[data-jj-product-hint]');
    if (!productField || !variantField || !variantTitle || !label) return;
    var edited = false;
    if (input) input.addEventListener('input', function () {
      edited = true;
      productField.value = ''; variantField.value = ''; variantTitle.value = '';
      label.hidden = true; label.textContent = '';
      if (hint) hint.hidden = true;
    });
    var params = new URLSearchParams(window.location.search);
    var desired = handle(productField.value) || handle(params.get('model'));
    if (!desired || (input && input.value && !productField.value)) return;
    var localeRoot = form.getAttribute('data-jj-ops-root') || '/';
    if (!/^(?:\/|\/[a-z]{2}(?:-[A-Za-z]{2})?\/?)$/.test(localeRoot)) return;
    var endpoint = localeRoot.replace(/\/$/, '') + '/products/' + encodeURIComponent(desired) + '.js';
    var controller = new AbortController();
    var timer = window.setTimeout(function () { controller.abort(); }, 6000);
    fetch(endpoint, { credentials: 'same-origin', redirect: 'error', signal: controller.signal, headers: { Accept: 'application/json' } })
      .then(function (response) { if (!response.ok) throw new Error('Product unavailable'); return response.json(); })
      .then(function (product) {
        if (edited) return;
        var result = choose(product, params, { handle: productField.value, variant: variantField.value, input: input ? input.value : '', qty: qty ? qty.value : '' });
        if (!result) return;
        productField.value = result.handle; variantField.value = result.variant; variantTitle.value = result.variantTitle;
        var title = result.title + (result.variantTitle && result.variantTitle !== 'Default Title' ? ' · ' + result.variantTitle : '');
        if (input && !input.value) { input.value = title; if (hint) hint.hidden = false; }
        if (qty && !qty.value && result.qty) { qty.value = result.qty; qty.dispatchEvent(new Event('input', { bubbles: true })); }
        label.textContent = title; label.hidden = false;
      })
      .catch(function () {
        // New-model enquiry pages point at DRAFT placeholder handles (no storefront product): fill the model text only, from a fixed allowlist; no product/variant is guessed.
        var names = { 'jucjet-t12-quote': 'JUCJET T12', 'jucjet-t22-quote': 'JUCJET T22', 'jucjet-t23-quote': 'JUCJET T23', 'jucjet-t28-quote': 'JUCJET T28', 'jucjet-dm1905l-quote': 'JUCJET DM1905L' };
        if (!edited && input && !input.value && !productField.value && Object.prototype.hasOwnProperty.call(names, desired)) {
          input.value = names[desired];
          if (hint) hint.hidden = false;
        }
      })
      .finally(function () { window.clearTimeout(timer); });
  }

  function syncProductLinks() {
    var productInfo = document.querySelector('product-info[id^="MainProduct-"]');
    if (!productInfo) return;
    var selected = productInfo.querySelector('form[action*="/cart/add"] input[name="id"]');
    var id = selected && selected.value;
    if (!/^\d{1,20}$/.test(id || '')) return;
    var productPath = new URL(productInfo.getAttribute('data-url'), window.location.origin).pathname;
    var model = handle(productPath.split('/').pop());
    if (!model) return;
    var root = productInfo.querySelector('[data-jj-b2b]');
    var table = root && root.querySelector('[data-jj-variant="' + id + '"]');
    var packs = productInfo.querySelector('input[name="quantity"]');
    var units = table ? quantity(table.getAttribute('data-units')) : '';
    var count = packs ? quantity(packs.value) : '1';
    var radios = units && count ? quantity(Number(units) * Number(count)) : '';
    document.querySelectorAll('a[href*="/pages/request-a-quote"]').forEach(function (link) {
      var url = new URL(link.href);
      if (url.origin !== window.location.origin || url.searchParams.get('model') !== model) return;
      var next = productURL(url.href, id, radios, link.hasAttribute('data-jj-quote-cta') || link.hasAttribute('data-jj-quote-link'));
      if (next) link.setAttribute('href', next);
    });
  }

  function mount() {
    if (typeof document === 'undefined') return;
    document.querySelectorAll('a[href*="/pages/request-a-quote"], a[href*="/pages/become-a-dealer"], a[href*="/pages/custom-products"]').forEach(function (link) {
      var next = testURL(link.href, window.location.search, window.location.origin);
      if (next) link.setAttribute('href', next);
    });
    document.querySelectorAll('.jj-quote__form').forEach(mountForm);
    syncProductLinks();
    if (productEvents || document.readyState === 'loading') return;
    productEvents = true;
    function deferredSync() { window.setTimeout(syncProductLinks, 0); }
    document.addEventListener('input', function (event) { if (event.target.name === 'quantity') deferredSync(); });
    document.addEventListener('change', deferredSync);
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) subscribe(PUB_SUB_EVENTS.variantChange, deferredSync);
  }

  return { quantity: quantity, handle: handle, choose: choose, productURL: productURL, testURL: testURL, mount: mount };
});
